module.exports = __webpack_public_path__ + "img/img_C2.1.3.81ab8b50.png";